import React, { useState } from "react";
import Grid from "@material-ui/core/Grid";
import { ReportSectionHeader } from "../../common/components/SectionHeader";
import { HeaderDivider } from "../../common/components/HeaderDivider";
import TermsAndConditions from "../../ace/TermsAndConditions";
import "./register.css";
import Axios from "axios";
import { apiUri } from "../../config";
import {
  NotificationManager,
  NotificationContainer,
} from "react-notifications";
import "react-notifications/lib/notifications.css";
import PrivacyPolicy from "../../ace/PrivacyPolicy";

function terms({ handleNext, user }) {
  const [accept, setAccept] = useState(false);
  const [acceptPrivacyPolicy, setAcceptPrivacyPolicy] = useState(false);
  const [termsScrolled, setTermsScrolled] = useState(false);
  const [privacyScrolled, setPrivacyScrolled] = useState(false);

  const handleAcceptTerms = (e) => {
  	if (termsScrolled) {
    	setAccept(e.target.checked);
  	} else {
  		 NotificationManager.error('Please scroll to the bottom of the Terms and Conditions to continue.', "Failure", 5000);
  	}
  };

  const handleAcceptPrivacyPolicy = (e) => {
  	if(privacyScrolled) {
      setAcceptPrivacyPolicy(e.target.checked);
  	} else {
  	  NotificationManager.error('Please scroll to the bottom of the Privacy Policy to continue.', "Failure", 5000);
  	}
  };

  const saveAgreementOfTerms = () => {
    if (accept) {
      const date = new Date();
      const formattedDate = date
        .toLocaleString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: false,
        })
        .replace(",", "");
      const payload = { acceptTos: formattedDate };
      Axios.put(
        `${apiUri}/register/acceptTos/${user.registrationUuid}`,
        payload
      )
        .then((res) => {
          handleNext();
        })
        .catch((err) => {
          console.log(err);
          NotificationManager.error(err.message, "Failure");
        });
    }
  };

  return (
    <Grid container>
      <Grid item xs={1}></Grid>
      <Grid item xs={10}>
        <ReportSectionHeader>
          <h4>ACE Alerts Subscription Terms And Conditions</h4>
        </ReportSectionHeader>
        <br />
        <HeaderDivider />
        <br />
        <TermsAndConditions onScrollToBottom={() => setTermsScrolled(true)} />
        <br />
        <div className="accept-terms-and-conditions" >
          <input
            type="checkbox"
            checked={accept && termsScrolled}
            name="termsAndConditions"
            className="sar-input-label"
            onChange={handleAcceptTerms}
          />
          &nbsp;&nbsp;
          <label htmlFor="termsAndConditions">
            I accept the terms and conditions
          </label>
        </div>
        <ReportSectionHeader>
          <h4>ACE Alerts Subscription Privacy Policy</h4>
        </ReportSectionHeader>
        <br />
        <HeaderDivider />
        <br />
        <PrivacyPolicy onScrollToBottom={() => setPrivacyScrolled(true)} />
        <br />
        <div className="accept-terms-and-conditions">
          <input
            type="checkbox"
            checked={acceptPrivacyPolicy && privacyScrolled}
            name="privacyPolicy"
            className="sar-input-label"
            onChange={handleAcceptPrivacyPolicy}
          />
          &nbsp;&nbsp;
          <label htmlFor="privacyPolicy">I accept the privacy policy</label>
        </div>
        <div className="right">
          <button
            className="sar-btn"
            disabled={!(accept && acceptPrivacyPolicy)}
            onClick={saveAgreementOfTerms}
          >
            Next
          </button>
        </div>
        <NotificationContainer />
      </Grid>
    </Grid>
  );
}

export default terms;



// WEBPACK FOOTER //
// ./src/components/Register/terms.jsx